
import React, {FC} from 'react';

import * as styles from './styles.module.scss';

type GroupProps = {
	color: string;
	min: number;
	max: number;
	text?: string;
}

const Group: FC<GroupProps> = ({color, min, max, text}) => {
	const c = (bg: boolean) => ({
		style: {
			[bg ? 'backgroundColor' : 'color']: color,
		}
	});

	return (
		<div className={styles.group}>
			<div className={styles.range}>
				<div className={styles.square} {...c(true)} />
				<span>{min}-{max}</span>
				<span className={styles.script}>th</span>
				<span>percentile</span>
			</div>
			<div className={styles.subtext} {...c(false)} >
				{text}
			</div>
		</div>
	);
};

export default Group;
